import React, { createContext, useContext } from 'react';
import useAzureConfigHook from '../../../hooks/Dashboard/azure/useConfig';

export const AzureConfigContext = createContext();

export const AzureConfigProvider = ({ children }) => {
  const data = useAzureConfigHook(); // Import everything from the hook

  return (
    <AzureConfigContext.Provider value={data}>
      {children}
    </AzureConfigContext.Provider>
  );
};

export const useAzureConfig = () => useContext(AzureConfigContext);